"use client";

import { Checkbox, FormControl, Label, LabelSupportingText } from "@sourceful/design-system-v3";
import { FieldMeta } from "@tanstack/react-form";
import { useCallback, useState } from "react";

export interface LeadGenConsentCheckboxProps {
  consentText: string;
  fieldMeta?: FieldMeta;
  onChange?: (e: any) => void;
}

export default function LeadGenConsentCheckbox({
  consentText,
  fieldMeta,
  onChange,
}: Readonly<LeadGenConsentCheckboxProps>) {
  const [value, setValue] = useState<boolean | undefined>(undefined);
  const [valid, setValid] = useState<boolean>(true);

  const checkValue = useCallback(() => {
    if (value === undefined || value === false) {
      setValid(false);
    } else {
      setValid(true);
    }
  }, [value]);

  const handleValueChange = useCallback(
    (value: boolean) => {
      onChange && onChange(value);
      setValue(value);
    },
    [onChange, setValue]
  );

  const error = !!fieldMeta?.errors.length || !valid;

  return (
    <FormControl layout="row">
      <Checkbox
        onFocus={checkValue}
        onCheckedChange={checked => {
          handleValueChange(checked === true);
          setValid(checked === true);
        }}
        id="consent"
        name="consent"
        aria-labelledby="consent-label"
        required
        error={error}
      />
      <Label id="consent-label" labelFor="consent">
        <LabelSupportingText>{consentText}</LabelSupportingText>
      </Label>
    </FormControl>
  );
}
